export default {
  API_ENDPOINT: 'https://calm-island-37678.herokuapp.com/api',
  TOKEN_KEY: process.env.HABIT_TRACKER_CLIENT_AUTH_TOKEN
}
